import { useMemo, useCallback } from 'react'
import { BirthCertificateDto, EarringDto } from 'src/dto/birth-certificate.dto'

interface UseAvailableEarringsParams {
  birthCertificateList?: BirthCertificateDto[]
  excludeIds?: string[]
}

interface UseAvailableEarringsReturn {
  availableEarrings: EarringDto[]
  selectFirstEarring: () => EarringDto | undefined
}

/**
 * Hook para gerenciar brincos disponíveis de fichas de nascimento
 * Filtra brincos com status 'novo' e não removidos, ordenados por ordem
 */
export const useAvailableEarrings = ({
  birthCertificateList,
  excludeIds = []
}: UseAvailableEarringsParams): UseAvailableEarringsReturn => {
  const availableEarrings = useMemo(() => {
    return (birthCertificateList || [])
      .flatMap((ficha) =>
        (ficha.brincos || []).filter(
          (brinco) => brinco.status.toLowerCase() === 'disponivel' && brinco.acao !== 'Removido'
        )
      )
      .filter((brinco) => !excludeIds.includes(brinco.idBrinco))
      .sort((a, b) => (a.ordem ?? 0) - (b.ordem ?? 0))
  }, [birthCertificateList, excludeIds])

  const selectFirstEarring = useCallback(() => {
    if (availableEarrings.length === 0) return undefined
    return availableEarrings[0]
  }, [availableEarrings])

  return {
    availableEarrings,
    selectFirstEarring
  }
}
